import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LotsHandoverContent from '../content/lotsHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class LotsHandover extends React.Component {
	static getTitle() {
		return 'Lots';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<LotsHandoverContent report={report} />
		);
	}
}

LotsHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	LotsHandover, {
		title: 'Lots',
		className: 'lots-handover'
	})
);
